import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.get('no-auth')) {
      let headers = request.headers;
      headers = headers.delete('no-auth');
      return next.handle(
        request.clone({
          headers,
        })
      );
    }
    return next.handle(
      request.clone({
        setHeaders: { Authorization: `Bearer ${this.auth.getToken()}` },
      })
    );
  }
}
